import React, { ChangeEvent, forwardRef } from "react";
import cx from "classnames";

import { Typography } from "../Typography/Typography";
import { InfoFilledIcon } from "~/ui-kit/icons/InfoFilled";

import "./Input.scss";

export type InputProps = {
  value: any;
  type: "text" | "number" | "email";
  name: string;
  className?: string;
  placeholder?: string;
  onChange: (newValue: any) => void;
  errorMessage?: string;
  isError?: boolean;
  onBlur?: any;
  IconComponent?: JSX.Element;
};

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const {
    value,
    type,
    name,
    placeholder,
    className = "",
    onChange,
    errorMessage,
    isError,
    onBlur,
    IconComponent,
  } = props;
  return (
    <>
      <div className="input-wrapper">
        <input
          ref={ref}
          value={value}
          type={type}
          name={name}
          placeholder={placeholder}
          className={cx(
            "input-container w-100 py-2 px-4 fs-md fw-md rounded-3",
            {
              error: isError,
            },
            className
          )}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            onChange(event.target.value)
          }
          onBlur={onBlur}
        />
        {IconComponent ? (
          <div className="icon-container">{IconComponent}</div>
        ) : null}
      </div>
      {errorMessage ? (
        <div className="d-flex align-items-center ps-2 mt-2">
          <InfoFilledIcon className="me-1" />
          <Typography weight="rg" size="xx" className="grey-500-c">
            {errorMessage}
          </Typography>
        </div>
      ) : null}
    </>
  );
});
